<template>
  <div>
    <div class="mb-2 px-3" v-for="(item, index) in listProgram" :key="index">
      <div class="d-column flex-row">
        <div class="no mt-3 d-flex flex-column pb-3 align-items-start">
          <div
            class="d-flex align-self-start d-flex flex-row align-items-start justify-content-start w-100"
          >
            <div class="mr-3" width="62">
              <object
                width="62"
                height="62"
                class="rounded-circle img-lg"
                :data="item.avatar"
                type="image/png"
              >
                <img
                  width="62"
                  height="62"
                  class="rounded-circle img-lg"
                  src="../assets/images/default.png"
                  alt="Avatar"
                />
              </object>
            </div>
            <div class="d-flex w-100">
              <div class="align-self-start mt-1 w-100">
                <div
                  class="row d-flex justify-content-between align-self-center"
                >
                  <h6 class="col pb-1">
                    <router-link
                      :to="'/program/detail?' + item._id"
                      class="link-block"
                    >
                      <strong v-text="item.name"></strong>
                    </router-link>
                  </h6>
                  <div class="ml-2">
                    <a
                      class="badge badge-warning text-white"
                      v-if="item.status == 'pending'"
                      v-text="$ml.get('pending')"
                      >Pendente</a
                    >
                    <a
                      class="badge badge-success text-white"
                      v-show="item.status == 'in_progress'"
                      v-text="$ml.get('inProgress')"
                      >Em andamento</a
                    >
                    <a
                      class="badge badge-secondary text-white"
                      v-show="item.status == 'paused'"
                      v-text="$ml.get('paused')"
                      >Pausado</a
                    >
                    <a
                      class="badge badge-dark text-white"
                      v-show="item.status == 'archived'"
                      v-text="$ml.get('archive')"
                      >Arquivado</a
                    >
                  </div>
                </div>
                <p class="d-flex align-items-center">
                  <span
                    class="align-self-center text-published"
                    v-text="
                      $ml
                        .with($utils.formatData(item.createdAt, $ml.get('ln')))
                        .get('publishedDaysAgo')
                    "
                  >
                  </span>
                </p>
                <div class="actions d-flex flex-row">
                  <VueCustomTooltip :label="$ml.get('ccpProgPriv')">
                    <span
                      v-show="item.type == 'private'"
                      class="ico ico-locked mr-1"
                    >
                      <img src="../assets/icons/lock.svg" class="ico-13" />
                    </span>
                  </VueCustomTooltip>
                  <VueCustomTooltip :label="$ml.get('credentialsTooltip')">
                    <span
                      v-if="item.type == 'private' && item.credential"
                      class="ico ico-credential mr-1"
                      data-toggle="tooltip"
                      data-placement="top"
                    >
                      <img src="../assets/icons/key-fill.svg" class="ico-18" />
                    </span>
                  </VueCustomTooltip>
                  <VueCustomTooltip label="Vulnerability Disclosure Program">
                    <span
                      v-if="item.type == 'vdp'"
                      class="ico ico-locked ico-vdp mr-1"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Programa Privado"
                    >
                      VDP
                    </span>
                  </VueCustomTooltip>
                  <VueCustomTooltip :label="$ml.get('ccpProgPubli')">
                    <span
                      v-show="item.type == 'public'"
                      class="ico ico-locked mr-1"
                    >
                      <img src="../assets/icons/unlock.svg" class="ico-13" />
                    </span>
                  </VueCustomTooltip>
                  <VueCustomTooltip :label="$ml.get('managedProgram')">
                    <span v-show="item.managed" class="ico ico-managed mr-1">
                      <img src="../assets/images/bughunt.svg" />
                    </span>
                  </VueCustomTooltip>
                  <VueCustomTooltip :label="$ml.get('protectedByNDA')">
                    <span v-if="item.nda_required" class="ico ico-nda mr-1">
                      <img src="../assets/icons/security-shield.svg" />
                    </span>
                  </VueCustomTooltip>
                  <VueCustomTooltip label="VPN">
                    <span v-if="item.vpn_required" class="ico ico-vpn mr-1">
                      <img src="../assets/images/vpn.png" />
                    </span>
                  </VueCustomTooltip>
                  <VueCustomTooltip :label="$ml.get('target')">
                    <span v-if="item.target" class="ico ico-vpn mr-1">
                      <img src="../assets/icons/target-icon.svg" />
                    </span>
                  </VueCustomTooltip>
                  <VueCustomTooltip :label="$ml.get('boostedProgram')">
                      <span
                        v-if="item.active_campaign"
                        class="ico ico-double mr-1"
                      >
                        <img
                          v-if="
                            item.offers_double_bounty == true &&
                            item.offers_double_score == true
                          "
                          src="../assets/icons/icon-diamante.svg"
                        />
                        <img
                          v-else-if="
                            item.offers_bounty == true &&
                            item.offers_double_score == false
                          "
                          src="../assets/icons/icon-double-reward.svg"
                        />
                        <img
                          v-else-if="
                            item.offers_double_bounty == false &&
                            item.offers_double_score == true
                          "
                          src="../assets/icons/icon-star.svg"
                        />
                      </span>
                   </VueCustomTooltip>
                  <ScoreMultiplierIcon
                    v-if="item.offers_bonus_score"
                    :bonus-score-value="item.bonus_score_value"
                  />
                </div>
                <hr />
                <div class="card-chart-body w-100">
                  <div class="row">
                    <div class="col-5 border-r-d mb-2">
                      <span class="pb-1" v-text="$ml.get('totalReports')"
                        >Total de relatórios</span
                      >
                      <h6>
                        <a>{{ item.totalReports }}</a>
                      </h6>
                    </div>
                    <div class="col-7 border-r-d pl-3 mb-2">
                      <span class="pb-1" v-text="$ml.get('dashReportResolv')"
                        >Relatórios encerrados</span
                      >
                      <h6>
                        <a>{{ item.totalApporvedReports ?? 0}}</a>
                      </h6>
                    </div>
                    <div class="col-4 border-r-d pl-3 mb-2">
                      <span class="pb-1" v-text="$ml.get('scope')">Escopo</span>
                      <h6>
                        <a>{{ item.totalScopes }}</a>
                      </h6>
                    </div>
                    <div class="col-8 pl-3 mb-2">
                      <span class="pb-1" v-text="$ml.get('rewards')"
                        >Recompensas</span
                      >
                      <div class="row mt-1">
                        <span
                          class="pr-2 d-flex align-items-center"
                          v-if="item.offersBounty"
                        >
                          <div
                            v-if="!item.target"
                            class="d-flex align-items-center"
                          >
                            <span v-if="currency === 'BRL'" class="currency"
                              >R$</span
                            >
                            <span v-else class="currency">$</span>
                            <font>{{
                              $ml.get(item?.currency.toUpperCase())
                            }}</font>
                          </div>
                          <div
                            v-if="item.target"
                            class="d-flex align-items-center"
                            style="gap: 5px"
                          >
                            <div
                              class="d-flex align-items-center"
                              v-for="(currency, index) in item.currency"
                              :key="index"
                            >
                              <span v-if="currency === 'BRL'" class="currency"
                                >R$</span
                              >
                              <span v-else class="currency">$</span>
                              <font>{{ $ml.get(currency.toUpperCase()) }}</font>
                            </div>
                          </div>
                        </span>
                        <span
                          class="d-flex align-items-center"
                          v-if="item.offersGift"
                        >
                          <img
                            src="../assets/icons/gift.svg"
                            class="ico-13 mr-1"
                          />
                          <font v-text="$ml.get('gift')">Brinde</font>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="m-0" v-if="listProgram.length != index + 1" />
    </div>
  </div>
</template>
<script>
import ScoreMultiplierIcon from "../components/ScoreMultiplierIcon";
export default {
  name: "ListProgram",
  props: ["listProgram"],
  components: {
    ScoreMultiplierIcon,
  },
  data(){
    return {
      currency: "",
    }
  },
  mounted() {
    this.currency = this.$store.getters["getUser"]?.currency;
  },
};
</script>
<style scoped>
.currency {
  font-weight: 500;
  margin-right: 3px;
}
</style>